
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'no-automation',
  templateUrl: './no-automation.component.html',
  standalone: true,
  imports: []
})
export class NoAutomationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}